/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './DashworksRpc';
import * as Queries from './DashworksRpc.dfc.new';
import type { AdditionalContextArgs } from './DashworksRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseFetchAppParamsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.FetchAppParamsResponseType>,
    References.FetchAppParamsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'fetchAppParams', References.FetchAppParamsResponseType>
        : References.FetchAppParamsResponseType)
    | undefined;
};

export function useFetchAppParamsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.FetchAppParamsResponseType>,
    References.FetchAppParamsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchAppParamsQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.FETCH_APP_PARAMS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchAppParams: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchAppParamsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseFetchAppParamsQueryReturn<T>;
}

type UseFetchAppParamsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.FetchAppParamsResponseType>,
    References.FetchAppParamsRequestType,
    T extends true
      ? Record<'fetchAppParams', References.FetchAppParamsResponseType>
      : References.FetchAppParamsResponseType
  >;

export function useFetchAppParamsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.FetchAppParamsResponseType>,
    References.FetchAppParamsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchAppParamsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.FETCH_APP_PARAMS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            fetchAppParams: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseFetchAppParamsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseFetchAppParamsLazyQueryReturn<T>;
}

type UseFetchAppParamsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.FetchAppParamsResponseType>,
    References.FetchAppParamsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'fetchAppParams', References.FetchAppParamsResponseType>
    : References.FetchAppParamsResponseType;
};

export function useFetchAppParamsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.FetchAppParamsResponseType>,
    References.FetchAppParamsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseFetchAppParamsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.FETCH_APP_PARAMS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            fetchAppParams: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseFetchAppParamsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseFetchAppParamsSuspenseQueryReturn<T>;
}

type UseStoreUserAppSecretQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.StoreUserAppSecretResponseType>,
    References.StoreUserAppSecretRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'storeUserAppSecret',
            References.StoreUserAppSecretResponseType
          >
        : References.StoreUserAppSecretResponseType)
    | undefined;
};

export function useStoreUserAppSecretQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.StoreUserAppSecretResponseType>,
    References.StoreUserAppSecretRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseStoreUserAppSecretQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.STORE_USER_APP_SECRET_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            storeUserAppSecret: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseStoreUserAppSecretQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseStoreUserAppSecretQueryReturn<T>;
}

type UseStoreUserAppSecretLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.StoreUserAppSecretResponseType>,
    References.StoreUserAppSecretRequestType,
    T extends true
      ? Record<'storeUserAppSecret', References.StoreUserAppSecretResponseType>
      : References.StoreUserAppSecretResponseType
  >;

export function useStoreUserAppSecretLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.StoreUserAppSecretResponseType>,
    References.StoreUserAppSecretRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseStoreUserAppSecretLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.STORE_USER_APP_SECRET_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            storeUserAppSecret: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseStoreUserAppSecretLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseStoreUserAppSecretLazyQueryReturn<T>;
}

type UseStoreUserAppSecretSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.StoreUserAppSecretResponseType>,
    References.StoreUserAppSecretRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'storeUserAppSecret', References.StoreUserAppSecretResponseType>
    : References.StoreUserAppSecretResponseType;
};

export function useStoreUserAppSecretSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.StoreUserAppSecretResponseType>,
    References.StoreUserAppSecretRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseStoreUserAppSecretSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.STORE_USER_APP_SECRET_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            storeUserAppSecret: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseStoreUserAppSecretSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseStoreUserAppSecretSuspenseQueryReturn<T>;
}

type UseGetAppIdsQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.GetAppIdsResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getAppIds', References.GetAppIdsResponseType>
        : References.GetAppIdsResponseType)
    | undefined;
};

export function useGetAppIdsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAppIdsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppIdsQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_APP_IDS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAppIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseGetAppIdsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetAppIdsQueryReturn<T>;
}

type UseGetAppIdsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAppIdsResponseType>,
    {},
    T extends true
      ? Record<'getAppIds', References.GetAppIdsResponseType>
      : References.GetAppIdsResponseType
  >;

export function useGetAppIdsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAppIdsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppIdsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APP_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAppIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAppIdsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAppIdsLazyQueryReturn<T>;
}

type UseGetAppIdsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<Record<'result', References.GetAppIdsResponseType>>,
  'data'
> & {
  data: T extends true
    ? Record<'getAppIds', References.GetAppIdsResponseType>
    : References.GetAppIdsResponseType;
};

export function useGetAppIdsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAppIdsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppIdsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APP_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAppIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAppIdsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAppIdsSuspenseQueryReturn<T>;
}

type UseGetBreezeConnectorAppIdsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetBreezeConnectorAppIdsResponseType>
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getBreezeConnectorAppIds',
            References.GetBreezeConnectorAppIdsResponseType
          >
        : References.GetBreezeConnectorAppIdsResponseType)
    | undefined;
};

export function useGetBreezeConnectorAppIdsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetBreezeConnectorAppIdsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetBreezeConnectorAppIdsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_BREEZE_CONNECTOR_APP_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getBreezeConnectorAppIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetBreezeConnectorAppIdsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetBreezeConnectorAppIdsQueryReturn<T>;
}

type UseGetBreezeConnectorAppIdsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetBreezeConnectorAppIdsResponseType>,
    {},
    T extends true
      ? Record<
          'getBreezeConnectorAppIds',
          References.GetBreezeConnectorAppIdsResponseType
        >
      : References.GetBreezeConnectorAppIdsResponseType
  >;

export function useGetBreezeConnectorAppIdsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetBreezeConnectorAppIdsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetBreezeConnectorAppIdsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_BREEZE_CONNECTOR_APP_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getBreezeConnectorAppIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetBreezeConnectorAppIdsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetBreezeConnectorAppIdsLazyQueryReturn<T>;
}

type UseGetBreezeConnectorAppIdsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetBreezeConnectorAppIdsResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getBreezeConnectorAppIds',
        References.GetBreezeConnectorAppIdsResponseType
      >
    : References.GetBreezeConnectorAppIdsResponseType;
};

export function useGetBreezeConnectorAppIdsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetBreezeConnectorAppIdsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetBreezeConnectorAppIdsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_BREEZE_CONNECTOR_APP_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getBreezeConnectorAppIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetBreezeConnectorAppIdsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetBreezeConnectorAppIdsSuspenseQueryReturn<T>;
}

type UseGetUserConnectedAppsQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.GetUserConnectedAppsResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getUserConnectedApps',
            References.GetUserConnectedAppsResponseType
          >
        : References.GetUserConnectedAppsResponseType)
    | undefined;
};

export function useGetUserConnectedAppsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetUserConnectedAppsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUserConnectedAppsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_USER_CONNECTED_APPS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getUserConnectedApps: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetUserConnectedAppsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetUserConnectedAppsQueryReturn<T>;
}

type UseGetUserConnectedAppsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetUserConnectedAppsResponseType>,
    {},
    T extends true
      ? Record<
          'getUserConnectedApps',
          References.GetUserConnectedAppsResponseType
        >
      : References.GetUserConnectedAppsResponseType
  >;

export function useGetUserConnectedAppsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetUserConnectedAppsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUserConnectedAppsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_USER_CONNECTED_APPS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getUserConnectedApps: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetUserConnectedAppsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetUserConnectedAppsLazyQueryReturn<T>;
}

type UseGetUserConnectedAppsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetUserConnectedAppsResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getUserConnectedApps',
        References.GetUserConnectedAppsResponseType
      >
    : References.GetUserConnectedAppsResponseType;
};

export function useGetUserConnectedAppsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetUserConnectedAppsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetUserConnectedAppsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_USER_CONNECTED_APPS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getUserConnectedApps: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetUserConnectedAppsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetUserConnectedAppsSuspenseQueryReturn<T>;
}

type UseGetMcpServersByIdsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetMcpServersByIdsResponseType>,
    References.GetMcpServersByIdsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getMcpServersByIds',
            References.GetMcpServersByIdsResponseType
          >
        : References.GetMcpServersByIdsResponseType)
    | undefined;
};

export function useGetMcpServersByIdsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetMcpServersByIdsResponseType>,
    References.GetMcpServersByIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServersByIdsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_MCP_SERVERS_BY_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getMcpServersByIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetMcpServersByIdsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetMcpServersByIdsQueryReturn<T>;
}

type UseGetMcpServersByIdsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetMcpServersByIdsResponseType>,
    References.GetMcpServersByIdsRequestType,
    T extends true
      ? Record<'getMcpServersByIds', References.GetMcpServersByIdsResponseType>
      : References.GetMcpServersByIdsResponseType
  >;

export function useGetMcpServersByIdsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetMcpServersByIdsResponseType>,
    References.GetMcpServersByIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServersByIdsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_MCP_SERVERS_BY_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getMcpServersByIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetMcpServersByIdsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetMcpServersByIdsLazyQueryReturn<T>;
}

type UseGetMcpServersByIdsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetMcpServersByIdsResponseType>,
    References.GetMcpServersByIdsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getMcpServersByIds', References.GetMcpServersByIdsResponseType>
    : References.GetMcpServersByIdsResponseType;
};

export function useGetMcpServersByIdsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetMcpServersByIdsResponseType>,
    References.GetMcpServersByIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetMcpServersByIdsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_MCP_SERVERS_BY_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getMcpServersByIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetMcpServersByIdsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetMcpServersByIdsSuspenseQueryReturn<T>;
}

type UseDisconnectUserAppMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.DisconnectUserAppResponseType>,
    References.DisconnectUserAppRequestType,
    T extends true
      ? Record<'disconnectUserApp', References.DisconnectUserAppResponseType>
      : References.DisconnectUserAppResponseType
  >;

export function useDisconnectUserAppMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.DisconnectUserAppResponseType>,
    References.DisconnectUserAppRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseDisconnectUserAppMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.DISCONNECT_USER_APP_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            disconnectUserApp: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseDisconnectUserAppMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseDisconnectUserAppMutationReturn<T>;
}

type UseTestGimmieSetupQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.TestGimmieSetupResponseType>,
    References.TestGimmieSetupRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'testGimmieSetup', References.TestGimmieSetupResponseType>
        : References.TestGimmieSetupResponseType)
    | undefined;
};

export function useTestGimmieSetupQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.TestGimmieSetupResponseType>,
    References.TestGimmieSetupRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseTestGimmieSetupQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.TEST_GIMMIE_SETUP_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            testGimmieSetup: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseTestGimmieSetupQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseTestGimmieSetupQueryReturn<T>;
}

type UseTestGimmieSetupLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.TestGimmieSetupResponseType>,
    References.TestGimmieSetupRequestType,
    T extends true
      ? Record<'testGimmieSetup', References.TestGimmieSetupResponseType>
      : References.TestGimmieSetupResponseType
  >;

export function useTestGimmieSetupLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.TestGimmieSetupResponseType>,
    References.TestGimmieSetupRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseTestGimmieSetupLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.TEST_GIMMIE_SETUP_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            testGimmieSetup: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseTestGimmieSetupLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseTestGimmieSetupLazyQueryReturn<T>;
}

type UseTestGimmieSetupSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.TestGimmieSetupResponseType>,
    References.TestGimmieSetupRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'testGimmieSetup', References.TestGimmieSetupResponseType>
    : References.TestGimmieSetupResponseType;
};

export function useTestGimmieSetupSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.TestGimmieSetupResponseType>,
    References.TestGimmieSetupRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseTestGimmieSetupSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.TEST_GIMMIE_SETUP_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            testGimmieSetup: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseTestGimmieSetupSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseTestGimmieSetupSuspenseQueryReturn<T>;
}

type UseTestGimmieCleanupQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.TestGimmieCleanupResponseType>,
    References.TestGimmieCleanupRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'testGimmieCleanup', References.TestGimmieCleanupResponseType>
        : References.TestGimmieCleanupResponseType)
    | undefined;
};

export function useTestGimmieCleanupQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.TestGimmieCleanupResponseType>,
    References.TestGimmieCleanupRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseTestGimmieCleanupQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.TEST_GIMMIE_CLEANUP_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            testGimmieCleanup: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseTestGimmieCleanupQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseTestGimmieCleanupQueryReturn<T>;
}

type UseTestGimmieCleanupLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.TestGimmieCleanupResponseType>,
    References.TestGimmieCleanupRequestType,
    T extends true
      ? Record<'testGimmieCleanup', References.TestGimmieCleanupResponseType>
      : References.TestGimmieCleanupResponseType
  >;

export function useTestGimmieCleanupLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.TestGimmieCleanupResponseType>,
    References.TestGimmieCleanupRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseTestGimmieCleanupLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.TEST_GIMMIE_CLEANUP_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            testGimmieCleanup: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseTestGimmieCleanupLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseTestGimmieCleanupLazyQueryReturn<T>;
}

type UseTestGimmieCleanupSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.TestGimmieCleanupResponseType>,
    References.TestGimmieCleanupRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'testGimmieCleanup', References.TestGimmieCleanupResponseType>
    : References.TestGimmieCleanupResponseType;
};

export function useTestGimmieCleanupSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.TestGimmieCleanupResponseType>,
    References.TestGimmieCleanupRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseTestGimmieCleanupSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.TEST_GIMMIE_CLEANUP_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            testGimmieCleanup: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseTestGimmieCleanupSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseTestGimmieCleanupSuspenseQueryReturn<T>;
}

type UseRunRetrievalEvalSingleQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.RunRetrievalEvalSingleResponseType>,
    References.RunRetrievalEvalSingleRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'runRetrievalEvalSingle',
            References.RunRetrievalEvalSingleResponseType
          >
        : References.RunRetrievalEvalSingleResponseType)
    | undefined;
};

export function useRunRetrievalEvalSingleQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.RunRetrievalEvalSingleResponseType>,
    References.RunRetrievalEvalSingleRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRunRetrievalEvalSingleQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.RUN_RETRIEVAL_EVAL_SINGLE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            runRetrievalEvalSingle: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseRunRetrievalEvalSingleQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseRunRetrievalEvalSingleQueryReturn<T>;
}

type UseRunRetrievalEvalSingleLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.RunRetrievalEvalSingleResponseType>,
    References.RunRetrievalEvalSingleRequestType,
    T extends true
      ? Record<
          'runRetrievalEvalSingle',
          References.RunRetrievalEvalSingleResponseType
        >
      : References.RunRetrievalEvalSingleResponseType
  >;

export function useRunRetrievalEvalSingleLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.RunRetrievalEvalSingleResponseType>,
    References.RunRetrievalEvalSingleRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRunRetrievalEvalSingleLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.RUN_RETRIEVAL_EVAL_SINGLE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            runRetrievalEvalSingle: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseRunRetrievalEvalSingleLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseRunRetrievalEvalSingleLazyQueryReturn<T>;
}

type UseRunRetrievalEvalSingleSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.RunRetrievalEvalSingleResponseType>,
    References.RunRetrievalEvalSingleRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'runRetrievalEvalSingle',
        References.RunRetrievalEvalSingleResponseType
      >
    : References.RunRetrievalEvalSingleResponseType;
};

export function useRunRetrievalEvalSingleSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.RunRetrievalEvalSingleResponseType>,
    References.RunRetrievalEvalSingleRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRunRetrievalEvalSingleSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.RUN_RETRIEVAL_EVAL_SINGLE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            runRetrievalEvalSingle: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseRunRetrievalEvalSingleSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseRunRetrievalEvalSingleSuspenseQueryReturn<T>;
}

type UseRunRetrievalEvalQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.RunRetrievalEvalResponseType>,
    References.RunRetrievalEvalRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'runRetrievalEval', References.RunRetrievalEvalResponseType>
        : References.RunRetrievalEvalResponseType)
    | undefined;
};

export function useRunRetrievalEvalQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.RunRetrievalEvalResponseType>,
    References.RunRetrievalEvalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRunRetrievalEvalQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.RUN_RETRIEVAL_EVAL_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            runRetrievalEval: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseRunRetrievalEvalQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseRunRetrievalEvalQueryReturn<T>;
}

type UseRunRetrievalEvalLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.RunRetrievalEvalResponseType>,
    References.RunRetrievalEvalRequestType,
    T extends true
      ? Record<'runRetrievalEval', References.RunRetrievalEvalResponseType>
      : References.RunRetrievalEvalResponseType
  >;

export function useRunRetrievalEvalLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.RunRetrievalEvalResponseType>,
    References.RunRetrievalEvalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRunRetrievalEvalLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.RUN_RETRIEVAL_EVAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            runRetrievalEval: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseRunRetrievalEvalLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseRunRetrievalEvalLazyQueryReturn<T>;
}

type UseRunRetrievalEvalSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.RunRetrievalEvalResponseType>,
    References.RunRetrievalEvalRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'runRetrievalEval', References.RunRetrievalEvalResponseType>
    : References.RunRetrievalEvalResponseType;
};

export function useRunRetrievalEvalSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.RunRetrievalEvalResponseType>,
    References.RunRetrievalEvalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRunRetrievalEvalSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.RUN_RETRIEVAL_EVAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            runRetrievalEval: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseRunRetrievalEvalSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseRunRetrievalEvalSuspenseQueryReturn<T>;
}

type UseRunRetrievalEvalFromGoogleSheetQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.RunRetrievalEvalFromGoogleSheetResponseType>,
    References.RunRetrievalEvalFromGoogleSheetRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'runRetrievalEvalFromGoogleSheet',
            References.RunRetrievalEvalFromGoogleSheetResponseType
          >
        : References.RunRetrievalEvalFromGoogleSheetResponseType)
    | undefined;
};

export function useRunRetrievalEvalFromGoogleSheetQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.RunRetrievalEvalFromGoogleSheetResponseType>,
    References.RunRetrievalEvalFromGoogleSheetRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRunRetrievalEvalFromGoogleSheetQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.RUN_RETRIEVAL_EVAL_FROM_GOOGLE_SHEET_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            runRetrievalEvalFromGoogleSheet: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseRunRetrievalEvalFromGoogleSheetQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseRunRetrievalEvalFromGoogleSheetQueryReturn<T>;
}

type UseRunRetrievalEvalFromGoogleSheetLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.RunRetrievalEvalFromGoogleSheetResponseType>,
    References.RunRetrievalEvalFromGoogleSheetRequestType,
    T extends true
      ? Record<
          'runRetrievalEvalFromGoogleSheet',
          References.RunRetrievalEvalFromGoogleSheetResponseType
        >
      : References.RunRetrievalEvalFromGoogleSheetResponseType
  >;

export function useRunRetrievalEvalFromGoogleSheetLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.RunRetrievalEvalFromGoogleSheetResponseType>,
    References.RunRetrievalEvalFromGoogleSheetRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRunRetrievalEvalFromGoogleSheetLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.RUN_RETRIEVAL_EVAL_FROM_GOOGLE_SHEET_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            runRetrievalEvalFromGoogleSheet: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseRunRetrievalEvalFromGoogleSheetLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseRunRetrievalEvalFromGoogleSheetLazyQueryReturn<T>;
}

type UseRunRetrievalEvalFromGoogleSheetSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.RunRetrievalEvalFromGoogleSheetResponseType>,
      References.RunRetrievalEvalFromGoogleSheetRequestType
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'runRetrievalEvalFromGoogleSheet',
          References.RunRetrievalEvalFromGoogleSheetResponseType
        >
      : References.RunRetrievalEvalFromGoogleSheetResponseType;
  };

export function useRunRetrievalEvalFromGoogleSheetSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.RunRetrievalEvalFromGoogleSheetResponseType>,
    References.RunRetrievalEvalFromGoogleSheetRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRunRetrievalEvalFromGoogleSheetSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.RUN_RETRIEVAL_EVAL_FROM_GOOGLE_SHEET_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            runRetrievalEvalFromGoogleSheet: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseRunRetrievalEvalFromGoogleSheetSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseRunRetrievalEvalFromGoogleSheetSuspenseQueryReturn<T>;
}
